import moment from 'moment'

export const parsableDateFormat = 'YYYY-MM-DD'
export const dateFormat = 'MM/DD/YYYY'

export const parsableDateTimeFormat = 'YYYY-MM-DDTHH:mm'
export const dateTimeFormat = 'MM/DD/YYYY HH:mm'

export const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch {
    return 'UTC'
  }
}

// Legacy API datetimes without an offset are UTC. Calendar-only values stay dates.
export const browserTime = (value) => {
  if (value == null || value === '') return moment.invalid()
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return moment(value, 'YYYY-MM-DD', true)
  }
  return moment.utc(value, moment.ISO_8601, true).local()
}

export const browserDate = value => browserTime(value).toDate()
